import usePagination from "@/hooks/usePagination";
import { useMemo } from "react";
import useGetCreditRetirementListForRegistry from "./useGetCreditRetirementListForRegistry";

export const useGetCreditRetirementListForRegistryPagination = () => {
	const pagination = usePagination();
	const creditRetirementList = useGetCreditRetirementListForRegistry(pagination.limit, pagination.offset);
	return useMemo(
		() => ({
			creditRetirementList,
			pagination,
		}),
		[creditRetirementList, pagination],
	);
};
